import { connect } from 'react-redux';
import { createNewUser } from '../../../actions/users';
import NewUserModal from './NewUserModal';
import commonActions from '../../../actions/common';

const usersConfigActions = commonActions('users');

const mapStateToProps = ({ isNewUserModalOpen, newUserState, users }) => ({
  users,
  isNewUserModalOpen,
  newUserState,
});

const mapDispatchToProps = dispatch => ({
  createNewUser: (itemId, data) => dispatch(createNewUser(data)),
  closeNewUserModal: () => dispatch(usersConfigActions.closeNewModal()),
});

const NewUserModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewUserModal);

export default NewUserModalContainer;



// WEBPACK FOOTER //
// ./src/components/Settings/users/NewUserModalContainer.js